export const encodeCourseId = (id) => {
  if (id === null || id === undefined) {
    console.error("Attempted to encode null or undefined ID.");
    return "";
  }
  try {
    const idString = String(id); // Ensure it's a string
    return btoa(idString);
  } catch (e) {
    console.error("Failed to encode course ID:", id, e);
    return "";
  }
};

export const decodeCourseId = (encodedId) => {
  if (!encodedId) {
    console.error("Attempted to decode null or empty ID.");
    return null;
  }
  try {
    return atob(encodedId); // This will return a string.
  } catch (e) {
    console.error("Failed to decode course id:", e); // This is the error you're seeing
    return null;
  }
};